
import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import Modal from "react-modal";
import * as XLSX from "xlsx";
import "./Custmizemenu.css";
import DEFAULT_IMAGE from "./food.jpg";
import { Link } from "react-router-dom";
import { addNewDish, getMenuByVendor } from "../../../../Component/Servicefile/Menuapiservice";
Modal.setAppElement("#root");

export default function Cateringcustomizemenu() {



    const [isQuickModal, setIsQuickModal] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [menu, setMenu] = useState([]);
    // const [filteredMenu, setFilteredMenu] = useState([]);
    const [isVegSelected, setIsVegSelected] = useState(null); // null = all
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [filteredMenu, setFilteredMenu] = useState([]); // if you need filtering

    const [isSaving, setIsSaving] = useState(false); // add this at the top of your component


    const [quickForm, setQuickForm] = useState({
        name: "",
        image: null,
        type: "veg",
    });

    const [isDetailModal, setIsDetailModal] = useState(false);
    const [editRowId, setEditRowId] = useState(null); // keep track if editing
    const [detailForm, setDetailForm] = useState({
        name: "",
        category: "",
        price: "",
        quantity: "",
        consumed: "",
        chefType: "",
        type: "veg",
        image: null,
    });
    const [isEditModal, setIsEditModal] = useState(false);
    const [editForm, setEditForm] = useState({
        id: null,
        name: "",
        category: "",
        price: "",
        discount: "",
        description: "",
        type: "veg",
        image: null
    });

    const handleAddClick = (item) => {
        // Show alert with the selected dishId
        // alert(`Selected Dish ID (parentId): ${item.dishId || item.id}`);

        // Open modal
        setIsDetailModal(true);

        // Pre-fill parentId for subcategory
        setEditRowId(item.dishId || item.id); // store existing dishId

        // Reset form
        setDetailForm({
            name: "",
            category: "",
            price: "",
            discount: "",
            description: "",
            image: null,
            type: "veg"
        });
    };



    const handleEditSave = async () => {
        try {
            const authToken = localStorage.getItem("authToken");
            if (!authToken) throw new Error("No auth token found. Please login.");

            const dishPayload = {
                dishId: editForm.id,
                dishName: editForm.name,
                dishDescription: editForm.description || editForm.category || "",
                dishPrice: Number(editForm.price),
                parentId: editForm.parentId || 0,
                discountPercentage: Number(editForm.discount || 0),
                effectivePrice: Number(editForm.effectivePrice || 0),
                dishType:
                    editForm.type === "veg"
                        ? "Veg"
                        : editForm.type === "nonveg"
                            ? "Non_veg"
                            : "Drinks",
                available: editForm.available ?? true,
            };

            const formData = new FormData();
            formData.append("dishData", new Blob([JSON.stringify(dishPayload)], { type: "application/json" }));

            if (editForm.image instanceof File) {
                formData.append("image", editForm.image); // ✅ Use "image" key
            }

            // console.log("📦 FormData entries:");
            for (let [key, value] of formData.entries()) {
                // console.log(key, value instanceof File ? value.name : value);
            }

            const response = await fetch(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/admin/${editForm.id}`,
                {
                    method: "PUT",
                    headers: { Authorization: `Bearer ${authToken}` },
                    body: formData,
                }
            );

            const text = await response.text();
            // console.log("🔹 Raw response text:", text);

            if (!response.ok) throw new Error(`PUT error! Status: ${response.status} | ${text}`);

            const updatedItem = JSON.parse(text);
            // console.log("✅ Updated item JSON:", updatedItem);

            // Update menu state
            setMenu(prev =>
                prev.map(item =>
                    item.id === updatedItem.dishId
                        ? {
                            ...item,
                            name: updatedItem.dishName,
                            description: updatedItem.dishDescription,
                            price: updatedItem.dishPrice,
                            dishType: updatedItem.dishType,
                            image: updatedItem.dishImage
                                ? updatedItem.dishImage + "?t=" + new Date().getTime()
                                : item.image,
                            discount: updatedItem.discountPercentage,
                            effectivePrice: updatedItem.effectivePrice,
                            available: updatedItem.available,
                        }
                        : item
                )
            );

            setFilteredMenu(prev =>
                prev.map(item =>
                    item.id === updatedItem.dishId
                        ? {
                            ...item,
                            image: updatedItem.dishImage
                                ? updatedItem.dishImage + "?t=" + new Date().getTime()
                                : item.image,
                        }
                        : item
                )
            );

            alert("✅ Item updated successfully!");
            setIsEditModal(false);
            window.location.reload();
        } catch (err) {
            console.error("Failed to update item:", err);
            alert("Failed to update item: " + (err.message || "Unknown error"));
        }
    };

    const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const authToken = localStorage.getItem("authToken");
        if (!authToken) {
            alert("No auth token found. Please login again.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file); // ✅ Attach Excel file

        try {
            // console.log("📤 Uploading Excel file:", file.name);

            const response = await fetch(
                "http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/admin/dishes/import",
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        // ❌ Do NOT set Content-Type manually — browser sets multipart boundary automatically
                        Accept: "*/*",
                    },
                    body: formData,
                }
            );

            const text = await response.text();
            // console.log("📥 Raw response text:", text);

            if (!response.ok) {
                throw new Error(`HTTP ${response.status} - ${text}`);
            }

            // If backend returns JSON with imported dishes
            const result = JSON.parse(text);
            // console.log("✅ Parsed Import Result:", result);

            alert("✅ Menu imported successfully from Excel!");

            // Optional: update your menu state if backend returns new dishes
            if (Array.isArray(result)) {
                setMenu((prev) => [...prev, ...result]);
            }

        } catch (error) {
            console.error("🚨 Import failed:", error);
            alert("❌ Import failed: " + (error.message || "Unknown error"));
        } finally {
            // Reset input (so same file can be re-selected)
            event.target.value = "";
        }
    };









    const handleEditChange = (e) => {
        const { name, files, value } = e.target;

        if (name === "image" && files && files[0]) {
            setEditForm(prev => ({ ...prev, image: files[0] })); // keep File object
        } else {
            setEditForm(prev => ({ ...prev, [name]: value }));
        }
    };


    const handleDetailSave = async () => {
        try {
            setIsSaving(true);

            const authToken = localStorage.getItem("authToken");
            if (!authToken) throw new Error("No auth token found. Please login.");

            // Prepare the dish data (JSON, without image)
            const dishData = {
                dishId: 0, // new subcategory
                dishName: detailForm.name || "",
                dishDescription: detailForm.description || detailForm.category || "",
                dishPrice: Number(detailForm.price || 0),
                parentId: editRowId, // parent dishId
                discountPercentage: Number(detailForm.discount || 0),
                effectivePrice:
                    Number(detailForm.price || 0) -
                    (Number(detailForm.price || 0) * Number(detailForm.discount || 0)) / 100,
                available: true,
                dishType:
                    detailForm.type === "veg"
                        ? "Veg"
                        : detailForm.type === "nonveg"
                            ? "Non_veg"
                            : "Drinks",
            };

            // Create FormData
            const formDataToSend = new FormData();
            formDataToSend.append(
                "dishData",
                new Blob([JSON.stringify(dishData)], { type: "application/json" })
            );

            // Append image file if selected
            if (detailForm.image instanceof File) {
                formDataToSend.append("image", detailForm.image);
            }

            // POST request
            const response = await fetch(
                "http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/admin/dishes",
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        // ❌ Do NOT set Content-Type manually
                    },
                    body: formDataToSend,
                }
            );

            const text = await response.text();
            // console.log("🔹 Raw response:", text);

            if (!response.ok) {
                throw new Error(text);
            }

            const savedDish = JSON.parse(text);
            alert("✅ Subcategory added successfully!");

            // Update local menu
            setMenu(prev => [
                ...prev,
                { ...detailForm, id: savedDish.dishId, image: detailForm.image },
            ]);

            // Reset form
            setDetailForm({
                name: "",
                category: "",
                price: "",
                discount: "",
                description: "",
                image: null,
                type: "veg",
            });
            setIsDetailModal(false);
        } catch (err) {
            console.error("❌ Failed to save subcategory:", err);
            alert("❌ Failed to save subcategory: " + (err.message || "Unknown error"));
        } finally {
            setIsSaving(false);
        }
    };






    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                resolve(reader.result); // keep the data URI prefix
            };
            reader.onerror = (error) => reject(error);
        });
    };



    const getValidImageUrl = (url) => {
        if (!url) return DEFAULT_IMAGE; // fallback image

        try {
            // If already data URI
            if (url.startsWith("data:image/")) return url;

            // Decode URL
            let decoded = decodeURIComponent(url);

            // Fix duplicate localhost path
            if (decoded.startsWith("http://localhost:9000/caterings/http")) {
                const parts = decoded.split("http://localhost:9000/caterings/");
                decoded = `http://localhost:9000/caterings/${parts[parts.length - 1]}`;
            }

            return decoded;
        } catch (err) {
            console.error("Error parsing image URL:", err);
            return DEFAULT_IMAGE;
        }
    };





    const handleDetailChange = (e) => {
        const { name, value, files } = e.target;

        if (name === "image") {
            setDetailForm(prev => ({ ...prev, image: files[0] || null }));
        } else {
            setDetailForm(prev => ({ ...prev, [name]: value }));
        }
    };
    const fetchImageBlob = async (url) => {
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error("Failed to fetch image");
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } catch (err) {
            console.error(err);
            return DEFAULT_IMAGE; // fallback
        }
    };

    useEffect(() => {
        const fetchMenu = async () => {
            setLoading(true);
            setError(null);
            try {
                const data = await getMenuByVendor();
                // console.log("✅ Raw API Data:", data);

                const formattedMenu = await Promise.all(
                    data.map(async (item) => {
                        // Process image
                        let imageUrl = getValidImageUrl(item.dishImage);

                        // If imageUrl is a URL (not base64), fetch blob
                        if (!imageUrl.startsWith("data:image/")) {
                            imageUrl = await fetchImageBlob(imageUrl);
                        }

                        return {
                            id: item.dishId,
                            name: item.dishName,
                            description: item.dishDescription,
                            price: item.dishPrice,
                            parentId: item.parentId,
                            image: imageUrl, // final image
                            discount: item.discountPercentage,
                            effectivePrice: item.effectivePrice,
                            available: item.available,
                            dishType: item.dishType || "-",
                            category: item.category || "-",
                            chefType: item.chefType || "-",
                            gst: item.gst || "-",

                        };
                    })
                );

                // console.log("🔹 Formatted Menu with images:", formattedMenu);
                setMenu(formattedMenu);
                setFilteredMenu(formattedMenu); // initially, no filter applied
            } catch (err) {
                console.error("Error fetching menu:", err);
                setError("Failed to load menu.");
            } finally {
                setLoading(false);
            }
        };

        fetchMenu();
    }, []);


    // Convert File to base64

    useEffect(() => {
        localStorage.setItem("menuData", JSON.stringify(menu));
    }, [menu]);


    const handleQuickSave = async () => {
        if (!quickForm.name) {
            alert("Enter item name!");
            return;
        }

        setIsLoading(true);

        try {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            // Prepare the dish data (JSON, without the image)
            const dishData = {
                dishName: quickForm.name,
                dishPrice: Number(quickForm.price || 0),
                available: true,
                dishType: quickForm.dishType || "Veg",
                dishDescription: quickForm.description || "",
            };

            // Create FormData
            const formDataToSend = new FormData();
            formDataToSend.append(
                "dishData",
                new Blob([JSON.stringify(dishData)], { type: "application/json" })
            );

            // Append image file only
            if (quickForm.image instanceof File) {
                formDataToSend.append("image", quickForm.image);
            }

            // POST request
            const response = await fetch(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/admin/dishes`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // ❌ Do NOT set Content-Type manually
                    },
                    body: formDataToSend,
                }
            );

            const text = await response.text();
            // console.log("🔹 Raw response:", text);

            if (!response.ok) {
                throw new Error(text);
            }

            alert("✅ Dish added successfully!");

            // Update local menu
            const savedDish = JSON.parse(text);
            setMenu(prev => [
                ...prev,
                {
                    ...quickForm,
                    id: savedDish.dishId,
                    image: quickForm.image, // keep for display
                    status: true,
                },
            ]);

            // Reset form
            setQuickForm({ name: "", price: "", image: null, dishType: "Veg" });
            setIsQuickModal(false);
        } catch (error) {
            console.error("❌ Error adding dish:", error);
            alert(`❌ Failed to add dish: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };





    const getBase64WithoutPrefix = (dataUri) => {
        if (!dataUri) return null;
        return dataUri.includes(",") ? dataUri.split(",")[1] : dataUri;
    };


    const handleQuickChange = (e) => {
        const { name, files, value } = e.target;
        if (name === "image" && files && files[0]) {
            setQuickForm(prev => ({ ...prev, image: files[0] })); // save as File
        } else {
            setQuickForm(prev => ({ ...prev, [name]: value }));
        }
    };







    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this item?")) return;

        try {
            setIsSaving(true); // optional: show loading

            const authToken = localStorage.getItem("authToken");
            if (!authToken) throw new Error("No auth token found. Please login.");

            const response = await fetch(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/admin/delete/${id}`,
                {
                    method: "DELETE",
                    headers: {
                        "Accept": "*/*",
                        Authorization: `Bearer ${authToken}`
                    }
                }
            );

            if (!response.ok) {
                const text = await response.text();
                throw new Error(`DELETE error! Status: ${response.status} | ${text}`);
            }

            alert("Item deleted successfully!");

            // Update local state to remove the deleted item
            setMenu(prev => prev.filter(item => item.id !== id));
            setFilteredMenu(prev => prev.filter(item => item.id !== id));
        } catch (err) {
            console.error("Failed to delete item:", err);
            alert("Failed to delete item: " + (err.message || "Unknown error"));
        } finally {
            setIsSaving(false);
        }
    };

    const handleEdit = (item) => {
        setEditForm({
            id: item.id,
            name: item.name || "",
            category: item.category || "",
            price: item.price || "",
            discount: item.discount || "",
            description: item.description || "",
            image: item.image || null,
            type: item.dishType === "Veg" ? "veg" : item.dishType === "Non_veg" ? "nonveg" : "drinks",
        });
        setIsEditModal(true);
    };


    // Export Excel
    const handleExport = () => {
        const ws = XLSX.utils.json_to_sheet(menu);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Menu");
        XLSX.writeFile(wb, "menu.xlsx");
    };


    // Toggle handler
    const handleFilterClick = (type) => {
        if (type === "Veg") {
            setFilteredMenu(menu.filter(item => item.dishType?.toLowerCase() === "veg"));
            setIsVegSelected(true);
        } else if (type === "Non-Veg") {
            setFilteredMenu(menu.filter(item => {
                const t = item.dishType?.toLowerCase();
                return t === "non-veg" || t === "nonveg" || t === "non_veg";
            }));
            setIsVegSelected(false);
        } else {
            setFilteredMenu(menu);
            setIsVegSelected(null);
        }
    };






    return (
        <div className="container-fluid" style={{ marginTop: "150px" }}><div className="row"> <div className="col-lg-2"></div><div className="col-lg-10">  <div className="menu-container">
            <p
                className="breadcrumb maamaas-home-bredcum or9"
                style={{
                    position: "fixed",
                    top: "64px",
                    width: "100%",
                    backgroundColor: "#fff",
                    padding: "31px 0",
                    fontSize: "18px",
                    fontWeight: "bold",
                    textAlign: "center",
                    height: "35px",
                    margin: 0,
                    zIndex: "999",
                }}
            >
                <Link
                    to="/Homes"
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Home
                </Link>

                <span className="separator"> &gt; </span>
                <span style={{ color: "purple", fontWeight: "bold" }}>
                    <Link

                        style={{
                            color: "purple",
                            fontWeight: "bold",
                            textDecoration: "none",
                        }}
                    >
                        Menu_Management
                    </Link>
                </span>  <span className="separator"> &gt; </span>
                <span style={{ color: "purple", fontWeight: "bold" }}>
                    <Link

                        style={{
                            color: "purple",
                            fontWeight: "bold",
                            textDecoration: "none",
                        }}
                    >
                        Catering & Services
                    </Link>
                </span>
            </p>
            {/* Top Bar */}
            <div className="top-bar">
                <div className="left-side">
                    <button className="add-btn" onClick={() => setIsQuickModal(true)}>
                        <FaPlus /> Add Item
                    </button>
                </div>
                <div className="menu-right-side">
                    <button className="menu-export-btn" onClick={handleExport}>Export</button>
                    <label className="menu-import-btn">
                        Import
                        <input type="file" hidden onChange={handleImport} />
                    </label>
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper" style={{ marginTop: "30px", height: "500px", scrollbarWidth: "thin" }}>
                <table className="menu-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Category</th>
                            <th>Image</th>
                            <th>
                                <div
                                    onClick={() => {
                                        if (isVegSelected === null) handleFilterClick("Veg");
                                        else handleFilterClick(isVegSelected ? "Non-Veg" : "Veg");
                                    }}
                                    className="veg-toggle"
                                    style={{
                                        backgroundColor: isVegSelected === null ? "#888" : isVegSelected ? "green" : "red",
                                        color: "#fff",
                                        padding: "4px",
                                        borderRadius: "4px",
                                        cursor: "pointer"
                                    }}
                                >
                                    {isVegSelected === null ? "Type" : isVegSelected ? "Veg" : "Non-Veg"}
                                </div>
                            </th>
                            <th>Price</th>
                            {/* <th>Chef Type</th> */}
                            <th>Discount</th>
                            <th>description</th>
                            {/* <th>Add Subcategory</th> */}
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredMenu
                            .filter(item => !item.parentId)
                            .map((item, index) => (
                                <React.Fragment key={item.id}>
                                    {/* Category Row */}
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td>{item.name}</td>
                                        <td>
                                            <img
                                                src={getValidImageUrl(item.image)}
                                                alt={item.name}
                                                className="item-img"
                                                style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                            />
                                        </td>
                                        <td>{item.dishType}</td>
                                        <td>{item.category}</td>
                                        <td>{item.chefType}</td>
                                        <td>{item.gst}</td>
                                        <td>
                                            <button className="row-add-btn" onClick={() => handleAddClick(item)}>Add</button>
                                            <FaEdit className="action-icon edit" onClick={() => handleEdit(item)} />
                                            <FaTrash className="action-icon delete" onClick={() => handleDelete(item.id)} />
                                        </td>
                                    </tr>

                                    {/* Subcategory Rows */}
                                    {filteredMenu
                                        .filter(sub => sub.parentId === item.id)
                                        .map((subItem) => (
                                            <tr key={subItem.id} style={{ backgroundColor: "#f9f9f9" }}>
                                                <td>-</td>
                                                <td style={{ paddingLeft: "30px" }}>↳ {subItem.name}</td>
                                                <td>
                                                    <img
                                                        src={getValidImageUrl(subItem.image)} // ✅ use subItem.image here
                                                        alt={subItem.name}
                                                        className="item-img"
                                                        style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                                    />
                                                </td>
                                                <td>{subItem.dishType}</td>
                                                <td>{subItem.price}</td>
                                                <td>{subItem.discount}%</td>
                                                <td>{subItem.description}</td>
                                                <td>
                                                    <FaEdit className="action-icon edit" onClick={() => handleEdit(subItem)} />
                                                    <FaTrash className="action-icon delete" onClick={() => handleDelete(subItem.id)} />
                                                </td>
                                            </tr>
                                        ))}
                                </React.Fragment>
                            ))}
                    </tbody>


                </table>
            </div>


            <Modal
                isOpen={isEditModal}
                onRequestClose={() => setIsEditModal(false)}
                className="detail-modal-content"
                overlayClassName="modal-overlay"
            >
                <h3>Edit Item</h3>
                <div className="form-group">
                    <input
                        type="text"
                        name="name"
                        placeholder="Item Name"
                        value={editForm.name}
                        onChange={handleEditChange}
                    />
                    <input
                        type="text"
                        name="category"
                        placeholder="Category"
                        value={editForm.category}
                        onChange={handleEditChange}
                    />
                    <input
                        type="number"
                        name="price"
                        placeholder="Price"
                        value={editForm.price}
                        onChange={handleEditChange}
                    />
                    <input
                        type="number"
                        name="discount"
                        placeholder="Discount %"
                        value={editForm.discount}
                        onChange={handleEditChange}
                    />
                    <input
                        type="text"
                        name="description"
                        placeholder="Description"
                        value={editForm.description}
                        onChange={handleEditChange}
                    />

                    {/* Display current image */}
                    {editForm.image && !(editForm.image instanceof File) && (
                        <img
                            src={getValidImageUrl(editForm.image)}
                            alt="Current"
                            style={{ width: "100px", height: "100px", objectFit: "cover", marginBottom: "10px" }}
                        />
                    )}

                    <input type="file" name="image" onChange={handleEditChange} />

                    <select name="type" value={editForm.type} onChange={handleEditChange}>
                        <option value="veg">Veg</option>
                        <option value="nonveg">Non-Veg</option>
                    </select>
                </div>

                <div className="modal-actions">
                    <button className="cancel-btn" onClick={() => setIsEditModal(false)}>Cancel</button>
                    <button className="save-btn" onClick={handleEditSave}>Save</button>
                </div>
            </Modal>


            {/* Quick Add Modal */}
            <Modal
                isOpen={isQuickModal}
                onRequestClose={() => setIsQuickModal(false)}
                className="quick-modal-content"
                overlayClassName="modal-overlay"
            >
                <h3>Add Category</h3>
                <div className="form-group">
                    <input
                        type="text"
                        name="name"
                        placeholder="Item Name"
                        value={quickForm.name}
                        onChange={handleQuickChange}
                    />
                    <input type="file" name="image" onChange={handleQuickChange} />
                    <select name="dishType" value={quickForm.dishType} onChange={handleQuickChange}>
                        <option value="Veg">Veg</option>
                        <option value="Non_veg">Non-Veg</option>
                        <option value="Drinks">Drinks</option>
                    </select>
                </div>
                <div className="modal-actions">
                    <button className="cancel-btn" onClick={() => setIsQuickModal(false)}>
                        Cancel
                    </button>
                    <button className="save-btn" onClick={handleQuickSave} disabled={isLoading}>
                        {isLoading ? "Adding..." : "Add"}
                    </button>
                </div>
            </Modal>


            {/* Detail Modal */}
            <Modal
                isOpen={isDetailModal}
                onRequestClose={() => setIsDetailModal(false)}
                className="detail-modal-content"
                overlayClassName="modal-overlay"
            >
                <h3>{editRowId ? "Add Subcategory" : "Add Details"}</h3>
                <div className="form-group">

                    {/* Display selected parentId */}
                    <input
                        type="text"
                        name="parentId"
                        placeholder="Parent Dish ID"
                        value={editRowId || ""}
                        readOnly
                    />

                    <input
                        type="text"
                        name="name"
                        placeholder="Item Name"
                        value={detailForm.name}
                        onChange={handleDetailChange}
                    />
                    {/* <input
                        type="text"
                        name="category"
                        placeholder="Category"
                        value={detailForm.category}
                        onChange={handleDetailChange}
                    /> */}
                    <input
                        type="number"
                        name="price"
                        placeholder="Price"
                        value={detailForm.price}
                        onChange={handleDetailChange}
                    />
                    <input
                        type="number"
                        name="discount"
                        placeholder="Discount %"
                        value={detailForm.discount}
                        onChange={handleDetailChange}
                    />
                    <input
                        type="text"
                        name="description"
                        placeholder="Description"
                        value={detailForm.description}
                        onChange={handleDetailChange}
                    />
                    <input type="file" name="image" onChange={handleDetailChange} />
                    <select name="type" value={detailForm.type} onChange={handleDetailChange}>
                        <option value="veg">Veg</option>
                        <option value="nonveg">Non-Veg</option>
                        <option value="drinks">Drinks</option>
                    </select>

                </div>
                <div className="modal-actions">
                    <button className="cancel-btn" onClick={() => setIsDetailModal(false)}>Cancel</button>
                    <button
                        className="save-btn"
                        onClick={handleDetailSave}
                        disabled={isSaving}
                    >
                        {isSaving ? "Saving..." : "Save"}
                    </button>

                </div>
            </Modal>



        </div></div></div> </div>

    );
}
